export default __webpack_public_path__ + "static/media/Frame_184.5fdf959a.jpg";